module.exports = __webpack_public_path__ + "static/media/40-14.b13d68c7.mp3";